export default {"src":"/_next/static/media/CRDO.40e846a4.svg","height":18,"width":18};